import React, {useState} from 'react';
import '../styles/Footer.css'; // Import your CSS file
import '@fortawesome/fontawesome-free/css/all.min.css';
import { useTranslation } from "react-i18next";
import vodunDaysLogo from '../assets/vodundays_logo.png';
import ben from '../assets/ben.png';
import "../../i18n";
import { Link } from 'react-router-dom';
import CookieConsentModal  from './CookiesPage';
import { useLanguage } from './LanguageContext';

const Footer = () => {
  const [showModal, setShowModal] = useState(false);
  const [lang, setLanguage] = useState(localStorage.getItem("language") || "FRA");


  const { i18n } = useTranslation(); 
  const { t } = useTranslation();
  const { changeLanguage } = useLanguage();
  const handleFooterLanguageChange = (code) => {
    i18n.changeLanguage(code);  // Changer la langue
    changeLanguage(code);  // Mettre à jour l'état local de la langue
    localStorage.setItem("language", code);  // Sauvegarder dans localStorage
  };

  return (
    <footer className="footer">
      <div className="footer-section">
        <h3>{t('footer.localisation')}</h3>
        <p className="ouidah">OUIDAH</p>
        <p className="ouidah">{t('footer.country')}</p>
      </div>
      <div className="footer-section">
        <h3>{t('footer.active_links')}</h3>
        <ul>
  <li>
    <Link to="/" className="footer-item-link">{t('footer.home')}</Link>
  </li>
  <li>
    <Link to="/tickets" className="footer-item-link">{t('footer.tickets')}</Link>
  </li>
  <li>
    <Link to="/produits" className="footer-item-link">{t('footer.products')}</Link>
  </li>
  <li>
    <Link to="/tentes" className="footer-item-link">{t('footer.tents')}</Link>
  </li>
  <li>
    <a 
      href="https://vodundays.bj/contact/" 
      target="_blank" 
      rel="noopener noreferrer" 
      className="footer-item-link"
    >
      {t('footer.contacts')}
    </a>
  </li>
</ul>

      </div>
      <div className="footer-section">
      <h3>{t('footer.language')}</h3>
      <ul>
        <li onClick={() => handleFooterLanguageChange('ENG')}  className="footer-lang-item">
          English
        </li>
        <li onClick={() => handleFooterLanguageChange('FRA')}  className="footer-lang-item">
          Français
        </li>
        <li onClick={() => handleFooterLanguageChange('ESP')}  className="footer-lang-item">
          Español
        </li>
        <li onClick={() => handleFooterLanguageChange('POT')}  className="footer-lang-item">
        Português
        </li>
      </ul>
    </div>

      <div className="footer-section social">
        <h3>{t('footer.follow_us')}</h3>
        <div className="social-icons">
          <a href="https://www.facebook.com/vodundays?mibextid=LQQJ4d" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-facebook"></i>
          </a>
          <a href="https://x.com/vodundays" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-x-twitter"></i>
          </a>
          <a href="https://www.instagram.com/accounts/login/?next=https%3A%2F%2Fwww.instagram.com%2Fvodundays%2F&is_from_rle" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-instagram"></i>
          </a>
          <a href="https://www.youtube.com/playlist?list=PL6nGRnf5v3jg5ByAAlBgMpCKWi743C2HC" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-youtube"></i>
          </a>
          <a href="https://www.tiktok.com/@vodundays" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-tiktok"></i>
          </a>
        </div>

      </div>
      <div className="footer-bottom">
        <img src={vodunDaysLogo} alt="Vodun Days Logo" className="footer-logo" />
              <img
        src={ben}
        alt="Vodun Days Logo"
        className="footer-logos"
        style={{ cursor: 'pointer' }}
        onClick={() => window.open('https://benintourisme.bj/', '_blank', 'noopener,noreferrer')}
/>

        <div className="footer-links">
        <a 
    href="https://vodundays.bj/politique-de-confidentialite/" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    {t('footer.privacy_policy')}
  </a>
  <a 
    href="https://vodundays.bj/mentions-legales/" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    {t('footer.terms_conditions')}
  </a>

  <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            setShowModal(true); // Affiche le modal
          }}
        >
          {t('footer.cookies_policy')}
        </a>
</div>

        <p>{t('footer.copyright')}</p>
      </div>
      {showModal && (
        <CookieConsentModal isOpen={showModal} onClose={() => setShowModal(false)} />
      )}
    </footer>
  );
};

export default Footer;
